import {Button, Icon, css} from '@sail/ui/deprecated';
import {useTheme} from '@stripe-internal/conversations-ui';
import {IconAsset} from '@sail/icons/types';

type Props = {
  onPress: () => void;
  disabled: boolean;
  icon?: IconAsset;
  dataTestId?: string;
  children: React.ReactNode;
};

export function OptionButton({
  onPress,
  disabled = false,
  icon,
  dataTestId,
  children,
}: Props) {
  const theme = useTheme();

  return (
    <Button
      onPress={onPress}
      disabled={disabled}
      size="large"
      css={{
        '&:focus': {
          outline: theme.focusVisibleOutline,
          focusRing: theme.focusVisibleOutline ? css.value('none') : undefined,
        },
      }}
      data-testid={dataTestId}
    >
      {icon ? <Icon icon={icon} /> : null}
      {children}
    </Button>
  );
}
